<template>
  <PageSecondary class="burnout">
    <template #title>Крошка Енот и тот, кто сидит в пруду</template>
    <h4>Сказка о знании и смелости</h4>

    <vue-plyr class="plyr" :options="{settings:	[], speed: {selected: 1}}">
      <audio controls crossorigin playsinline>
        <source
            src="@/assets/voice/little-racoon.mp3"
            type="audio/mp3"
        />
      </audio>
    </vue-plyr>

<p>    Крошка Енот был маленьким, но храбрым.</p>
<p>    Однажды Мама Енотиха сказала:</p>
<p>    — Сегодня луна будет полной и светлой. Крошка Енот, можешь ли ты один сходить к быстрому ручью и принести раков на
    ужин?</p>
<p>    — Ну да, конечно, — ответил Крошка Енот. — Я наловлю вам таких раков, каких вы никогда ещё не ели.</p>
<p>    Крошка Енот был маленьким, но храбрым.</p>
<p>    Ночью взошла луна, большая и светлая.</p>
<p>    — Пора, Крошка Енот, — сказала мама. — Иди, пока ты не дойдёшь до пруда. Ты увидишь большое дерево, которое
    перекинуто через пруд. Перейди по нему на другую сторону. Это самое лучшее место для ловли раков.</p>
<p>    При свете луны Крошка Енот отправился в путь.</p>
<p>    Он был такой счастливый! Такой гордый!</p>
<p>    Вот он какой:</p>
<p>    Пошёл в лес</p>
<p>    Совсем один,</p>
<p>    Первый раз в жизни!</p>
<p>    Сперва он шёл не спеша,</p>
<p>    Потом чуть быстрее,</p>
<p>    А дальше — вприпрыжку.</p>
<p>    Вскоре Крошка Енот вошёл в густой-прегустой лес.</p>
<p>    Там отдыхал Старый Дикобраз.</p>
<p>    Он очень удивился, увидев, что Крошка Енот гуляет в лесу без мамы.</p>
<p>    — Куда ты идёшь совсем один? — спросил Старый Дикобраз.</p>
<p>    — К быстрому ручью! — ответил Крошка Енот гордо. — Я иду ловить раков на ужин.</p>
<p>    — А тебе не страшно, Крошка Енот? — спросил Старый Дикобраз. — Ты ведь знаешь, что у тебя нет того, что есть у меня,
    — таких острых и длинных иголок.</p>
<p>    — Я не боюсь! — ответил Крошка Енот: он был маленький, но храбрый.</p>
<p>    Крошка Енот пошёл дальше при свете яркой луны.</p>
<p>    Сперва он шёл не спеша.</p>
<p>    Потом чуть быстрее,</p>
<p>    А дальше — вприпрыжку.</p>
<p>    Вскоре он пришёл на зелёную полянку. Там сидел Большой Скунс. Он тоже удивился, почему Крошка Енот гуляет в лесу без
    мамы.</p>
<p>    — Куда ты идёшь совсем один? — спросил Большой Скунс.</p>
<p>    — К быстрому ручью! — ответил Крошка Енот гордо. — Я иду ловить раков на ужин.</p>
<p>    — А тебе не страшно, Крошка Енот? — спросил Большой Скунс. — Ты ведь знаешь, у тебя нет того, что есть у меня: я
    разбрызгиваю жидкость с противным запахом, и все убегают.</p>
<p>    — Я не боюсь! — сказал Крошка Енот и пошёл дальше.</p>
<p>    Недалеко от пруда он увидел Толстого Кролика.</p>
<p>    Толстый Кролик спал. Он приоткрыл один глаз и вскочил.</p>
<p>    — Ой, ты меня напугал! — сказал он. — Куда же ты идёшь совсем один, Крошка Енот?</p>
<p>    — Я иду к быстрому ручью! — сказал Крошка Енот гордо. — Это по ту сторону пруда.</p>
<p>    — Оо—ооо! — сказал Толстый Кролик. — А ты не боишься Его?</p>
<p>    — Кого мне бояться? — спросил Крошка Енот.</p>
<p>    — Того, кто сидит в пруду, — сказал Толстый Кролик. — Я Его боюсь!</p>
<p>    — Ну, а я не боюсь! — сказал Крошка Енот и пошёл дальше.</p>
<p>    И вот наконец Крошка Енот увидел большое дерево, которое было перекинуто через пруд.</p>
<p>    — Здесь мне надо перейти, — сказал сам себе Крошка Енот. — А там, на другой стороне, я буду ловить раков.</p>
<p>    Крошка Енот начал переходить по дереву на ту сторону пруда.</p>
<p>    Он был храбрым, но зачем только он повстречал Этого Толстого Кролика!</p>
<p>    Ему не хотелось думать о Том, кто сидит в пруду, но он ничего не мог с собой поделать.</p>
<p>    Он остановился и заглянул.</p>
<p>    Кто—то сидел в пруду!</p>
<p>    Это был Он! Сидел там и смотрел на Енота при свете луны. Крошка Енот и виду не подал, что испугался.</p>
<p>    Он скорчил рожу.</p>
<p>    Тот, в пруду, тоже скорчил рожу.</p>
<p>    Что это была за рожа!</p>
<p>    Крошка Енот повернул обратно и побежал со всех ног. Он так быстро промчался мимо Толстого Кролика, что тот опять
    напугался. И вот он бежал, бежал не останавливаясь, пока не увидел Большого Скунса.</p>
<p>    — Что такое? Что такое? — спросил Большой Скунс.</p>
<p>    — Там, в пруду, сидит Кто—то большой—пребольшой! — вскричал Крошка Енот. — Я не могу пройти!</p>
<p>    — Хочешь, я пойду с тобой и прогоню его? — спросил Большой Скунс.</p>
<p>    — О, нет, нет! — ответил Крошка Енот торопливо. — Вы не должны этого делать!</p>
<p>    — Ну, хорошо, — сказал Большой Скунс. — Тогда захвати с собой камень. Только чтобы показать Ему, что у тебя есть
    камень.</p>
<p>    Крошке Еноту хотелось принести домой раков. Поэтому он взял камень и пошёл обратно к пруду.</p>
<p>    — Может быть, Он уже ушёл! — сказал Крошка Енот сам себе.— Нет, Он не ушёл!</p>
<p>    Он сидел в пруду.</p>
<p>    Крошка Енот и виду не подал, что испугался.</p>
<p>    Он высоко поднял камень.</p>
<p>    Тот, кто сидел в пруду, тоже высоко поднял камень.</p>
<p>    Ой, какой это был большой камень!</p>
<p>    Крошка Енот был храбрый, но он был маленький. Он побежал со всех ног. Он бежал, бежал не останавливаясь, пока не
    увидел Старого Дикобраза.</p>
<p>    — Что такое? Что такое? — спросил Старый Дикобраз.</p>
<p>    Крошка Енот рассказал ему про Того, кто сидит в пруду.</p>
<p>    — У него тоже был камень! — сказал Крошка Енот. — Большой—пребольшой камень.</p>
<p>    — Ну, тогда захвати с собой палку, — сказал Старый Дикобраз, — вернись обратно и покажи ему, что у тебя есть большая
    палка.</p>
<p>    Крошке Еноту хотелось принести домой раков. И вот он взял палку и пошёл обратно к пруду.</p>
<p>    — Может быть, Он успел уйти, — сказал Крошка Енот сам себе.</p>
<p>    Нет, Он не ушёл!</p>
<p>    Он по—прежнему сидел в пруду.</p>
<p>    Крошка Енот не стал ждать. Он поднял вверх свою большую палку и погрозил ею.</p>
<p>    Но у Того, в пруду, тоже была палка. Большая—пребольшая палка! И он погрозил этой палкой Крошке Еноту.</p>
<p>    Крошка Енот уронил свою палку и побежал.</p>
<p>    Он бежал, бежал</p>
<p>    Мимо Толстого Кролика,</p>
<p>    Мимо Большого Скунса,</p>
<p>    Мимо Старого Дикобраза</p>
<p>    Не останавливаясь, до самого дома.</p>
<p>    Крошка Енот рассказал своей маме всё про Того, кто сидит в пруду.</p>
<p>    — О, мама, — сказал он, — мне так хотелось пойти одному за раками! Мне так хотелось принести их на ужин домой!</p>
<p>    — И ты принесёшь! — сказала Мама Енотиха. — Вот что я тебе скажу, Крошка Енот. Вернись назад, но на этот раз…</p>
<p>    Не строй рож,</p>
<p>    Не бери с собой камня,</p>
<p>    Не бери с собой палки!</p>
<p>    — Что же я должен делать? — спросил Крошка Енот.</p>
<p>    — Только улыбнуться! — сказала Мама Енотиха. — Пойди и улыбнись Тому, кто сидит в пруду.</p>
<p>    — И больше ничего? — спросил Крошка Енот. — Ты уверена?</p>
<p>    — Это всё, — сказала мама. — Я уверена.</p>
<p>    Крошка Енот был храбрым, и мама была в этом уверена.</p>
<p>    И он пошёл обратно к пруду.</p>
<p>    — Может быть, Он ушёл наконец! — сказал Крошка Енот сам себе.</p>
<p>    Нет, не ушёл!</p>
<p>    Он по—прежнему сидел в пруду.</p>
<p>    Крошка Енот заставил себя остановиться.</p>
<p>    Потом заставил себя заглянуть в воду.</p>
<p>    Потом заставил себя улыбнуться Тому, кто сидел в пруду.</p>
<p>    И Тот, кто сидел в пруду, улыбнулся в ответ!</p>
<p>    Крошка Енот так обрадовался, что стал хохотать. И ему показалось, что Тот, кто сидел в пруду, хохочет, точь—в—точь
    как это делают еноты, когда им весело.</p>
<p>    — Он хочет со мной дружить! — сказал сам себе Крошка Енот. — И теперь я могу перейти на ту сторону.</p>
<p>    И он побежал по дереву.</p>
<p>    Там, на берегу быстрого ручья, Крошка Енот принялся ловить раков.</p>
<p>    Скоро он набрал столько раков, сколько мог донести.</p>
<p>    Он побежал обратно по дереву через пруд.</p>
<p>    На этот раз Крошка Енот помахал рукой Тому, кто сидел в пруду.</p>
<p>    А Тот махнул ему рукой в ответ.</p>
<p>    Крошка Енот мчался домой со всех ног, крепко держа своих раков.</p>
<p>    Да! Никогда ещё ни он, ни его мама не едали таких вкусных раков. Так сказала Мама Енотиха.</p>
<p>    — Я теперь могу идти туда совсем один, когда хочешь! — сказал Крошка Енот. — Я больше не боюсь Того, кто сидит в
    пруду.</p>
<p>    — Я знаю, — сказала Мама Енотиха.</p>
<p>    — Он совсем не плохой, Тот, кто сидит в пруду! — сказал Крошка Енот.</p>
<p>    — Я знаю, — сказала Мама Енотиха. Крошка Енот посмотрел на маму.</p>
<p>    — Скажи мне, — сказал он. — Кто это сидит в пруду?</p>
<p>    Мама Енотиха рассмеялась.</p>
<p>    А потом сказала ему.</p>

  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
export default {
  name: "LittleRaccoon",
  components: {PageSecondary}
}
</script>

<style>
.plyr--audio .plyr__controls {
  padding: 0;
}
.plyr {
  --plyr-color-main: #000000;
  --plyr-control-spacing: 16px;
  --plyr-menu-radius: 20px;
  margin-bottom: 16px;
}
.plyr__volume {
  width: auto;
}
</style>

<style scoped>
  p {
    text-indent: 32px;
  }
</style>